import React from 'react'
import { REQUIRED_MESSAGE } from '@Const/error-messages'
import { FieldError } from 'react-hook-form'
import FormFieldProps from '@App/forms/v2/common/form-field'

interface FieldErrorSectionFormProps extends FormFieldProps {
    fieldError?: FieldError
}

const FieldErrorSectionForm = (props: FieldErrorSectionFormProps) => {
    const {
        assistiveText,
        assistiveTextFunction,
        assistiveTextVisibility = { errors: true, assistive: true },
        schema,
        fieldError,
    } = props

    const displayAssistiveText = assistiveText
        ? assistiveText
        : assistiveTextFunction
          ? assistiveTextFunction(!schema?.isOptional())
          : ''

    return (
        <>
            {fieldError && assistiveTextVisibility.errors ? (
                <p className="error-text small">{fieldError.message}</p>
            ) : (
                <>
                    {assistiveTextVisibility.assistive && (
                        <p className="assistive-text small">
                            {displayAssistiveText
                                ? displayAssistiveText
                                : !schema?.isOptional()
                                  ? REQUIRED_MESSAGE
                                  : 'Optional'}
                        </p>
                    )}
                </>
            )}
        </>
    )
}

export default FieldErrorSectionForm
